import { render, staticRenderFns } from "./Paystub.vue?vue&type=template&id=34a7215e&scoped=true&"
import script from "./Paystub.vue?vue&type=script&lang=js&"
export * from "./Paystub.vue?vue&type=script&lang=js&"
import style0 from "./Paystub.vue?vue&type=style&index=0&id=34a7215e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a7215e",
  null
  
)

export default component.exports